import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";
import { Dropdown } from "react-bootstrap";
import HttpClient from "../../../../../../../../../actions/http-client";
import { GET_WORKPLACE_GROUP_LIST } from "../../../../../../../../../actions/api";
import { TOAST_ERROR } from "../../../../../../../../../utils";


class WorkspaceFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            community: '',
            accessToken: '',
            error: false,
            noAccFoundError: false,
            selectedAcc: null,
            errorMsg: 'Community ID and Access Token required!',
            groupList: []
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, noAccFoundError: false });

    handleSelect = (item) => { this.setState({ selectedAcc: item, error: false }) }

    getGroupList = (callback) => {
        new HttpClient()
            .post(`${GET_WORKPLACE_GROUP_LIST}`, {
                community: this.state.community,
                accessToken: this.state.accessToken
            })
            .then((response) => {
                const { responseCode, responseData } = response.data;
                callback();
                if (responseCode == 200) {
                    if (responseData && responseData.length > 0) {
                        this.setState({ groupList: responseData });
                    } else {
                        this.setState({ noAccFoundError: true });
                    }
                }
            }).catch((ex) => {
                const errorMsg = ex.response.data ? ex.response.data.resposneMessage : '';
                TOAST_ERROR(errorMsg);
                callback();
            })
    }

    onSubmit = () => {
        const { updateStep } = this.props;
        const { accessToken, community, selectedAcc, groupList } = this.state;

        if (community != '' && accessToken != '') {
            if (selectedAcc !== null) {

                const obj = {
                    networkId: 15,
                    filter: 22,
                    communityId: community,
                    accessToken: accessToken,
                    workplaceGroup: selectedAcc.name,
                    workplaceGroupId: selectedAcc.id,
                    connetedAccount: 0,
                    moderation: 0
                }
                this.setState({ loading: true, error: false, noAccFoundError: false });

                updateStep(2, obj, () => this.setState({ loading: false }));

            } else {
                if (groupList.length == 0) {
                    this.setState({ loading: true, error: false, noAccFoundError: false });
                    this.getGroupList(() => this.setState({ loading: false }));
                } else {
                    this.setState({ error: true, errorMsg: 'Please select an option' })
                }
            }
        } else {
            this.setState({ error: true, errorMsg: 'Community ID and Access Token required!' });
        }
    }

    render() {
        const { community, accessToken, error, noAccFoundError, loading, groupList, selectedAcc, errorMsg } = this.state;

        return (
            <div className="ob-feed-form-wrapper w-100">
                <div className="selectSource-right mb-3">
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-users`}></i>
                            </span>
                            <InputField name={"community"} className="form-control p-3" value={community} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                    </div>
                </div>

                <div className="selectSource-right mb-2">
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-key`}></i>
                            </span>
                            <InputField name={"accessToken"} className="form-control p-3" value={accessToken} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                    </div>
                </div>
                {(groupList && groupList.length > 0) && <div id="workplace_div" className="form-group mb-0 w-100">
                    <Dropdown className="w-100 connected_acc__" id="connectedAll">
                        <Dropdown.Toggle className="btn w-100 border d-flex justify-content-between align-items-center mt-2">
                            {selectedAcc ? selectedAcc.name : "Select Group"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-100 navi flex-column navi-hover py-2 connectedAllAccounts">
                            {
                                groupList.map(item => (<Dropdown.Item className="navi-item px-3 py-3" onClick={e => this.handleSelect(item)} key={item.id}>
                                    {item.name}
                                </Dropdown.Item>))
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>}
                {error && <span id="workplace_error" className="errorMessage py-2 text-end">{errorMsg}</span>}
                {noAccFoundError && <span id="workplace_error" className="errorMessage py-2 text-end">No Group Found !</span>}
                <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between mt-3">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={!community.trim() || !accessToken.trim()} />
                </div>
            </div>
        )
    }
}

export default WorkspaceFeed;